module.exports = __webpack_public_path__ + "img/integral.131a0fbc.png";